import { Header } from './Header';
import { SiteFooter } from './SiteFooter';
import { Toaster } from '../ui/sonner';
import { WhatsAppButton, BackToTop } from '../common';

export function Layout({ children, hideWhatsApp = false, hideBackToTop = false }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-[108px] md:pt-[140px]">
        {children}
      </main>
      <SiteFooter />
      
      {/* Utility Components */}
      {!hideWhatsApp && <WhatsAppButton />}
      {!hideBackToTop && <BackToTop />}
      
      {/* Toast Notifications */}
      <Toaster position="top-right" richColors />
    </div>
  );
}
